import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getColumns } from "./resources";
import Structure from "./components/Structure";
import { articles } from "../../../../../store/Concept/selectors";

const Table = ({ addItem }) => {
  const columns = useMemo(() => getColumns(addItem), []);
  const data = useSelector(articles);

  return <Structure columns={columns} data={data} />;
};

export default Table;
